import React from 'react';
import {
  Switch,
  Route
} from "react-router-dom";
import {NewPage} from './Tools'


import Article from './Article';
import lists from "./lists";

function Page() {
  return (
    <div>
      <div className="Header">
        <div className="Title">
          <p>
            miaom's Blog
          </p>
        </div>
        <hr/>
      </div>

      <div className="Sidebar">
        <div className="Item" style={{"textAlign": "center"}}>
          <p>
          miaom's Blog
          </p>
          <hr/>
          <NewPage to="/home">首页</NewPage><br/>
          <NewPage to="/blog">博客</NewPage><br/>
          <NewPage to="/about">关于</NewPage>
        </div>
      </div>

      <div className="Content">
        <div className="Item">
          <Switch>
            <Route path={["/blog/:id","/about"]} component={Article} />
            <Route path="/blog" component={List} />
          </Switch>
        </div>
      </div>

      <div className="Footer">
        
      </div>
      
      {/* <button className="ScrollTop" onClick={()=>window.scroll(0,0)}>
        ↑
      </button> */}
    </div>
  );
}

class List extends React.Component{
  constructor(props) {
    super(props);
    this.state={article:lists.article};
  }
  render() {
    console.log(this);
    var rend = [],i;
    for (i=0;i<this.state.article.length;i++)
      rend[i]=<li key={i}><NewPage to={this.state.article[i].url}>{this.state.article[i].title}</NewPage></li>;
    return (
      <div>
        <ul>
          {rend}
        </ul>
        <br/>
        {"共" + this.state.article.length + "篇文章"}
      </div>
    );
  }
}

export default Page;